/*
 * @Author: your name
 * @Date: 2021-12-09 17:03:41
 * @LastEditTime: 2021-12-10 10:10:29
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \front-shared\packages\nail-free-login\src\utils\api.mappings.ts
 */
export interface ApiMap {
  [name: string]: {
    [key: string]: string;
  };
}

const original: ApiMap = {
  /**
   * 用户信息
   */
  user: {
    getInfo: '/api/organization/user/info',
    departments: '/api/organization/user/departments',
    orgLevel: '/api/organization/department/get_user_parent_depts',
    getLoginInfo: '/api/commonservice/organization/user/get_login_info',
    getDeptLeader: '/api/organization/user/getDeptLeaderInfoByUserId' // 根据用户id 获取部门主管信息
  },
  dingTalk: {
    sign: '/api/authorization/login/auth/sign',
    login: '/api/authorization/login/ding_talk'
  },
  wechat: {
    sign: '/api/authorization/login/auth/sign',
    login: '/api/authorization/login/wx_login'
  },
  org: {
    info: '/api/webapi/organization/department/list_organizations'
  },
  common: {
    systemConfig: '/public/system/config'
  }
};

const api = Object.assign({}, original);

export function assign (source: ApiMap) {
  if (!source) {
    return;
  }

  Object.keys(source).forEach(key => {
    if (api[key]) {
      api[key] = Object.assign({}, api[key], source[key]);
    } else {
      api[key] = source[key];
    }
  });
}

export default api;
